const EN_US = {
  'catalogAdminDomain.title': 'Catalog Admin',
  'catalogAdminDomain.imageManagement.title': 'Fix Image Alert',
  'catalogAdminDomain.imageUploads.title': 'Image Uploads',

  // Header Component
  'catalogAdminDomain.imageManagement.header.changeNotification': 'Change Email Notification',
  'catalogAdminDomain.imageManagement.header.settings': 'Settings',

  // List Component
  'catalogAdminDomain.imageManagement.list.title': 'Fix Image Alert',
  'catalogAdminDomain.imageManagement.list.columns.productImage': 'Product Image',
  'catalogAdminDomain.imageManagement.list.columns.productName': 'Product Name',
  'catalogAdminDomain.imageManagement.list.columns.upc': 'UPC Code',
  'catalogAdminDomain.imageManagement.list.columns.rrc': 'RRC Code',
  'catalogAdminDomain.imageManagement.list.columns.imageUrl': 'Image Url',
  'catalogAdminDomain.imageManagement.list.columns.imageProblem': 'Image Problem',
  'catalogAdminDomain.imageManagement.list.columns.removalDeadline': 'Removal Deadline',
  'catalogAdminDomain.imageManagement.list.actions': 'Actions',
  'catalogAdminDomain.imageManagement.list.viewImage': 'View Image',
  'catalogAdminDomain.imageManagement.list.moreActions': 'More Actions',
  'catalogAdminDomain.imageManagement.list.actions.removeImage': 'Remove/Hide Image',
  'catalogAdminDomain.imageManagement.list.actions.delayRemoval': 'Delay Removal By 14 Days',
  'catalogAdminDomain.imageManagement.list.actions.falsePositive': 'Mark As False Positive',
  'catalogAdminDomain.imageManagement.list.actions.editProduct': 'Edit Product',

  // Modal Component
  'catalogAdminDomain.imageManagement.modal.title': 'Settings',
  'catalogAdminDomain.imageManagement.modal.optOut': 'Opt Out',
  'catalogAdminDomain.imageManagement.modal.delayRemoval': 'Delay Removal',

  // Product Edit
  'catalogAdminDomain.productEdit.nav.title': 'Product Edit',
  'catalogAdminDomain.productEdit.show.breadcrumb.root': 'Product Edit',
  'catalogAdminDomain.productEdit.show.search.placeholder': 'Product ID',
  'catalogAdminDomain.productEdit.show.search.button': 'Edit',
  'catalogAdminDomain.ProductEdit.show.title': 'Product',
  'catalogAdminDomain.ProductEdit.show.emptyProduct': 'Please, enter a Product ID.',
  'catalogAdminDomain.ProductEdit.show.noProductFound': 'Product not found.',

  // Quality Audit Workflows
  'catalogAdminDomain.qualityAuditWorkflows.nav.title': 'Quality Audit Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.list.title': 'Workflow Management',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.launch': 'Launch',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.workflow': 'Workflow',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.taskCount': 'Task Count',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.source': 'Source',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.dueDate': 'Due Date',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.actions': 'Actions',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.productSources': 'Product Sources',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.productMatches': 'Product Matches',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.value.view': 'View',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.inputData': 'Input Data',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.column.inputData.value': 'View',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.addToMyWorkflows':
    'Add To My Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.comment':
    'Set Internal/External Comments',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.viewInputData': 'View Input Data',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.removeFromMyWorkflows':
    'Remove From My Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.subscribeToNotifications':
    'Subscribe To Notifications',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.actions.unsubscribeToNotifications':
    'Unsubscribe To Notifications',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.outsourceWorkflows.title':
    'Outsource Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.problemTrackerWorkflows.title':
    'Problem Tracker Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.list.table.automatedDetectWorkflows.title':
    'Automated Detect Workflows',

  'catalogAdminDomain.qualityAuditWorkflows.list.table.myWorkflows.title': 'My Workflows',
  'catalogAdminDomain.qualityAuditWorkflows.select.taskState.title': 'Filter Task State:',
  'catalogAdminDomain.qualityAuditWorkflows.select.taskState.pastDue': 'Past Due',
  'catalogAdminDomain.qualityAuditWorkflows.select.taskState.pending': 'Pending',
  'catalogAdminDomain.qualityAuditWorkflows.select.taskState.completed': 'Completed',
  'catalogAdminDomain.qualityAuditWorkflows.graph.title': 'Task Count',
  'catalogAdminDomain.qualityAuditWorkflows.graph.seriesName': 'Task Count',
  'catalogAdminDomain.qualityAuditWorkflows.graph.category.approvedTasks': 'Approved Tasks',
  'catalogAdminDomain.qualityAuditWorkflows.graph.category.rejectedTasks': 'Rejected Tasks',
  'catalogAdminDomain.qualityAuditWorkflows.graph.category.auditableTasks': 'Auditable Tasks',
  'catalogAdminDomain.qualityAuditWorkflows.range.title': 'Filter Due Date:',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.reassign.title': 'Select Reassignment',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.reassign.select.placeholder':
    'Select Workflow',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.button.reassign': 'Reassign',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.combine.title': 'Confirm Combine',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.combine.body':
    'You are about to combine several batches, please confirm action.',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.byPass.title': 'Confirm Release',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.byPass.body':
    'You are about to release the selected batches.',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.dueDate.title': 'Override Due Date',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.reject.title': 'Confirm Rejection',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.reject.body':
    'You are about to reject the following batch.',
  'catalogAdminDomain.qualityAuditWorkflows.batch.modal.sample.title': 'Override Sample Size',
  'catalogAdminDomain.qualityAuditWorkflows.batch.title': 'Batch Management',
  'catalogAdminDomain.qualityAuditWorkflows.batch.state.pending': 'Pending',
  'catalogAdminDomain.qualityAuditWorkflows.batch.state.rejected': 'Rejected',
  'catalogAdminDomain.qualityAuditWorkflows.batch.state.approved': 'Approved',
  'catalogAdminDomain.qualityAuditWorkflows.batch.state.bypassed': 'By Passed',
  'catalogAdminDomain.qualityAuditWorkflows.batch.state.force_rejected': 'Force Rejected',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.rework.title': 'Rework Batches for Audit',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.title': 'Workflow Batches for Audit',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.launch': 'Launch',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.batchNumber': 'Batch Number',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.description': 'Description',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.received': 'Received',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.recommendedSample':
    'Recommended Sample',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.sampleSize': 'Sample Size',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.numberAuditable': '# Auditable',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.dueDate': 'Due Date (UTC)',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.createdAt': 'Created At (UTC)',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.column.actions': 'Actions',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.action.overrideSampleSize':
    'Override Sample Size',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.action.rejectBatch': 'Reject Batch',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.action.overrideDueDate':
    'Override Due Date',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.button.release': 'Release Without Audit',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.button.combine': 'Combine',
  'catalogAdminDomain.qualityAuditWorkflows.batch.table.button.launch': 'Launch Audit',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.legends.title': 'Legend:',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.legends.valid': 'Valid Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.legends.validWithSuggestedValue':
    'Valid Value With Suggested Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.legends.validComments':
    'Valid Value With Comments',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.legends.invalid': 'Invalid Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.batchState': 'Batch State:',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.createdAt': 'Created At:',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.vendor': 'Vendor:',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.completedAt': 'Completed At:',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.title': 'Tasks for Auditing',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.button.submit': 'Submit Completed Tasks',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.dueDate': 'Due Date',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.acceptTask': 'Accept Task',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.rejectTask': 'Reject Task',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.state': 'State',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.entityId': 'Entity Id',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.upc': 'UPC Code',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.image': 'Image',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.freeze': 'Freeze Column',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.column.unfreeze': 'Unfreeze Column',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.actions.leaveComments':
    'Leave Internal/External Comment',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.flagValue': 'Flag Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.flagValueWithSuggestValue':
    'Flag Value With Suggested Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.table.comment': 'Comment',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.title.comments': 'Comments',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.title.input': 'Input Data',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.value': 'Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.flag': 'Flag',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.submit': 'Submit',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.close': 'Close',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.cancel': 'Cancel',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.valid': 'Valid',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.faq': 'FAQ',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.invalid': 'Invalid',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.internalComment':
    'Internal Comment (Optional)',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.externalComment':
    'External Comment (Optional)',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.suggestedValue': 'Suggested Value',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.notFound': 'No input data found',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.errorLoading':
    'Error while loading input data',

  'catalogAdminDomain.qualityAuditWorkflows.batch.errorMessage':
    'Unable to update batch, due to an issue, please try again later.',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.errorMessage':
    'Unable to save, because a conflict has occurred. Please, review and try again.',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.conflictMessage':
    'There was an update to the existing comments, please review it before saving.',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.tab.currentData': 'New Data',
  'catalogAdminDomain.qualityAuditWorkflows.tasks.modal.tab.conflictingData': 'Conflicting Data',
  'catalogAdminDomain.imageUploads.productNotFound': 'Item not found',
  'catalogAdminDomain.imageUploads.invalidImage': 'Failed to save image',
} as const

export default EN_US
